import { ProductImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/productImpression.trackingInfo";

import * as AlgoliaTrackingService from "@/services/algolia/algoliaTracking.service";
import * as AlgoliaUserService from "@/services/algolia/algoliaUser.service";
import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";
import { Config } from "@/utils/config.utils";

import {
    AlgoliaAnalyticsEventNames,
    AlgoliaAnalyticsEvents
} from "../AlgoliaAnalyticsEvents";
import {
    AlgoliaAnalyticsMinimumDataset,
    AlgoliaClickPayload
} from "../AlgoliaAnalyticsMinimumDataset";

export interface AlgoliaAnalyticsProductClickImpression
    extends AlgoliaAnalyticsMinimumDataset<AlgoliaClickPayload> {}

const getAlgoliaProductClickPayload = (
    eventData: ProductImpressionTrackingInfo
): AlgoliaClickPayload => {
    const lastQueryRecord = AlgoliaTrackingService.getLastQueryTrackRecordFor(
        eventData.id
    );

    return {
        authenticatedUserToken: AlgoliaUserService.getAuthenticatedUserToken(),
        eventName: AlgoliaAnalyticsEventNames.HitClicked,
        index: Config.integrations["algolia-index-product"],
        userToken: AlgoliaUserService.getUserToken(),
        queryID: lastQueryRecord?.queryID,
        objectIDs: [eventData.id],
        positions: lastQueryRecord?.position
            ? [lastQueryRecord?.position]
            : undefined
    };
};

const getAlgoliaAnalyticsProductClickImpression = (
    data: TypedAnalyticsEvent<ProductImpressionTrackingInfo>
): Array<AlgoliaAnalyticsProductClickImpression> => {
    const payload = getAlgoliaProductClickPayload(data.payload.eventData);

    return [
        {
            eventName: payload.queryID
                ? AlgoliaAnalyticsEvents.ClickedObjectIDsAfterSearch
                : AlgoliaAnalyticsEvents.ClickedObjectIDs,
            payload: payload
        }
    ];
};

export { getAlgoliaAnalyticsProductClickImpression };
